/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Grid,
  Header,
  Form as FormUi,
  Icon,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import moment from "moment";
import {vendor_vehicle} from './vendorConstants'

const VehicleDetailModal = ({
  id,
  data
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [VehicleDetail, setVehicleDetail] = useState([]);
  var vendorIndex = 0;

  useEffect(() => {
    getVehicleDetail();
  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  const handleSubmited = () => {
        setmodalOpen(false);
  };

  const getVehicleDetail = () => {
    ReadAxios({ url: `vehicleMaster/${id}` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVehicleDetail([])
          : setVehicleDetail(res.data.resultSet[0]);
      })
      .catch((err) => {
        setVehicleDetail([]);
      });
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        trigger={
        <Button 
            type="button" 
            add_mode="edit" 
            onClick={handleOpen} 
            size="mini"  
            basic 
            icon
        > 
            <Icon name="eye" /> 
        </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {vendor_vehicle?.titles?.vehicle_details||"Vehicle Details"}
        </Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
                <Grid columns={4} className="ml-2">
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.vehicle_no || "Vehicle Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.vehicleNumber ? VehicleDetail.vehicleNumber : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.vehicle_type||"Vehicle Type"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.vehicleType ? VehicleDetail.vehicleType : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                  <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.ownership_type||"Vehicle Owner"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.vehicleOwner ? VehicleDetail.vehicleOwner : "NA"}
                      </Header>
                    </Grid.Column>

                    
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.tracking_type||"Tracking Type"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.trackingType ? VehicleDetail.trackingType  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                  <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.gps_partner||"GPS Partner"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.vehicleGps ? VehicleDetail.vehicleGps  : "NA"}
                      </Header>
                    </Grid.Column>

                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.base_location||"Vehicle BaseLocation"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.vehicleBaseLocation ? VehicleDetail.vehicleBaseLocation : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.load_capacity||"Vehicle Capacity"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.vehicleCapacity ? VehicleDetail.vehicleCapacity : "NA"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.vehicle_dimension||"Vehicle Dimensions"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.vehicleDimensions ? VehicleDetail.vehicleDimensions  : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.puc||"PUC"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail?.vehiclePUCExpiryDate ? moment(VehicleDetail.vehiclePUCExpiryDate).format("DD-MM-YYYY") : "NA"}&nbsp;&nbsp;
                        
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.insurance||"Insurance"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleInsuranceExpiryDate ? moment(VehicleDetail.vehicleInsuranceExpiryDate).format("DD-MM-YYYY") : "NA"}&nbsp;&nbsp;
                        
                      </Header>
                      
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.fitness||"Fitness Certificate"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleFitnessCertExpiryDate ? moment(VehicleDetail.vehicleFitnessCertExpiryDate).format("DD-MM-YYYY") : "NA"}&nbsp;&nbsp;
                        
                      </Header>
                      
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.permit||"Permit"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehiclePermitExpiryDate ? moment(VehicleDetail.vehiclePermitExpiryDate).format("DD-MM-YYYY") : "NA"}&nbsp;&nbsp;
                        
                      </Header>
                      
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.rc_number||"Vehicle RC Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleRCNo ? VehicleDetail.vehicleRCNo : "NA"}<br></br>
                        {VehicleDetail.vehicleRCNo ? moment(VehicleDetail.vehicleRCNoExpiryDate).format("DD-MM-YYYY") : null}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {vendor_vehicle?.headers?.road_tax||"Road Tax Validity"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {VehicleDetail.vehicleRoadTaxValidityDate ?  moment(VehicleDetail.vehicleRoadTaxValidityDate).format("DD-MM-YYYY") : "NA"}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="submit"
            onClick={handleSubmited}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {vendor_vehicle?.buttons?.ok||"Ok"}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default VehicleDetailModal;
